import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { ProgramaVerificacionViewModel } from '../../programasverificacion/datosbasicos/pvcam-datosbasicos.types';

///https://angular.io/tutorial/toh-pt6
//https://malcoded.com/posts/angular-backend-asp-core

@Injectable()
export class ProgramaVerificacionService {
    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    private endpoint = this.baseUrl + 'api/campanias/programaverificacion/';
    private _pvCam: ProgramaVerificacionViewModel;

    //delete(id: number): Observable<ProgramaVerificacionViewModel> {
    //    return this.http.delete<ProgramaVerificacionViewModel>(this.endpoint + id).pipe();
    //}

    getById(id: number): Observable<ProgramaVerificacionViewModel> {
        return this.http.get<ProgramaVerificacionViewModel>(this.endpoint + id);
    }

    set pvCam(pvCam: ProgramaVerificacionViewModel) {
        this._pvCam = pvCam;
    }

    get pvCam(): ProgramaVerificacionViewModel {
        return this._pvCam;
    }

    save(payload: ProgramaVerificacionViewModel): Observable<any> {
        return this.http.put<ProgramaVerificacionViewModel>(this.endpoint, payload);
    }

    restore(payload: ProgramaVerificacionViewModel): Observable<any> {
        return this.http.put<ProgramaVerificacionViewModel>(this.endpoint + 'RestorePv/', payload);
    }

    accept(payload: ProgramaVerificacionViewModel): Observable<any> {
        return this.http.put<ProgramaVerificacionViewModel>(this.endpoint + 'AcceptPv/', payload);
    }

    reject(payload: ProgramaVerificacionViewModel): Observable<any> {
        return this.http.put<ProgramaVerificacionViewModel>(this.endpoint + 'RejectPv/', payload);
    }
}
